<template>
  <div v-if="loading_is_complete"
       class="product-block__feedback-area aside">
    <div class="aside__block">
      <form @submit.prevent="onSubmit" class="form-pp">
        <div class="form-pp__status" v-if="success || fail"
             :class="[!success && !fail  ? 'is-hidden': success ? 'is-ok' : fail ? 'is-error' : '']">
          <div class="form-pp__close-status" @click="success = false; fail = false">
            <span class="form-pp__close-status-part one"></span>
            <span class="form-pp__close-status-part two"></span>
          </div>
          <div class="form-pp__status-message" v-html="msg"></div>
        </div>
        <input name="product_id" type="number" hidden  v-model.number="product_id">
        <div class="heading-for-aside">Закажите консультацию по товару</div>
        <div class="form-pp__row">
          <label for="cat-cons-form_name" class="form-pp__label">* Как вас зовут?</label>
          <input name="name" v-model="name" type="text" id="cat-cons-form_name" class="input-v2 input-v2_medium" placeholder="">
        </div>
        <div class="form-pp__row">
          <label for="cat-cons-form_phone" class="form-pp__label">* Номер телефона</label>
          <input name="phone" v-model="phone" type="text" id="cat-cons-form_phone" class="input-v2 input-v2_medium" placeholder="">
        </div>
        <div class="form-pp__row">
          <label for="cat-cons-form_phone" class="form-pp__label">Город</label>
          <input name="city" v-model="city" type="text" id="cat-cons-form_city" class="input-v2 input-v2_medium" placeholder="">
        </div>
        <div class="form-pp__row">
          <label class="form-pp__label" style="line-height: 16px;">Нажимая на кнопку, вы даете согласие на обработку персональных данных и соглашаетесь c
            <a href="https://profpotok.ru/policy">политикой конфиденциальности</a></label>
        </div>
        <button class="button-v2 button-v2_colored-1 button-v2_small">
          <div class="button-v2__inner">
            <div class="button-v2__label">Отправить</div>
          </div>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from "axios";

export default {
  name: "ProductFeedBack",
  data() {
    return {
      name: "",
      phone: "",
      city: "",
      msg: "",
      success: false,
      fail: false,
    }
  },
  computed: {
    loading_is_complete() {
      return this.$store.getters['product/GET_LOADING_IS_COMPLETE']
    },
    product_id() {
      return this.$store.getters['product/GET_ID']
    },
  },
  methods: {
    onSubmit(){
      this.msg = ""
      this.success = false
      this.fail = false

      axios.post(`${process.env.VUE_APP_PRODUCT_FEEDBACK_URL}product_feedback`,
        {
          name: this.name,
          phone: this.phone,
          city: this.city,
          product_id: this.product_id,
        },
      )
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            // handle success
            this.success = true
            this.msg = "Спасибо! Данные успешно отправлены"
          })
          .catch((error) => {
            // handle error
            if (error.response.status == 401) {
              this.msg = "Не все поля заполнены! Попробуйте ещё раз."
              this.fail = true
            }else if(error.response.status == 429){
              this.msg = "Мы вас поняли."
              this.fail = true
            }else{
              this.msg = "Попробуйте позже"
              this.fail = true
            }
          })
          .then(function () {
            // always executed
          });
    },
  },
}
</script>

<style scoped>

</style>